<template>
  <div class="returnInvoicePage" v-if="!showLoad">
    <div class="claimDetailLists dzfp">
      <h4 class="title">到账分配</h4>
    </div>
    <ul class="listUl">
      <li class="listLi">
        <van-cell-group class="baseNone baseSalary dwBox">
          <van-field
            v-model="invoiceData.num"
            readonly
            rows="1"
            autosize
            type="textarea"
            class="ggInput textArea"
            input-align="right"
            label="发票号："
          />
          <van-field
            v-if="invoiceData.oppositeTallage!=''"
            v-model="invoiceData.oppositeTallage"
            readonly
            rows="1"
            autosize
            type="textarea"
            class="ggInput textArea"
            input-align="right"
            label="税号："
          />
          <van-field
            v-model="invoiceData.amount"
            readonly
            class="ggInput"
            input-align="right"
            label="开票金额（元）："
          />
          <div class="ljdz">
            <van-field
              v-model="invoiceData.amountTotal"
              readonly
              :is-link="invoiceData.amountTotal>0"
              class="ggInput"
              input-align="right"
              @click="jumpUrl"
              label="累计到账金额（元）："
            />
          </div>
          <van-field
            v-model="invoiceData.amountRemain"
            readonly
            class="ggInput"
            input-align="right"
            label="未到账金额（元）："
          />
          <van-field
            v-if="mode == 'add'"
            @input="moneyOnceChange"
            v-model="invoiceData.onceAmount"
            :readonly="!editType"
            clearable
            :required="editType"
            class="ggInput"
            input-align="right"
            label="本次到账金额（元）："
            :placeholder="editType?'请输入...  ':''"
          />
          <van-field
          v-if="mode == 'add'"
            label="到账时间："
            :required="editType"
            v-model="invoiceData.accountTime"
            @click="TimePicker"
            :is-link="editType"
            :placeholder="editType?'请选择':''"
            :input-align="right"
            class="ggInput"
            readonly
          />
        </van-cell-group>
      </li>
    </ul>
    <div class="claimDetailLists list">
      <h4 class="title">开票明细</h4>
    </div>
    <div v-for="item in propertyData" :key="item.id" class="warp">
      <van-cell-group class="baseNone beizhu">
        <van-field
          v-model="item.contractName"
          input-align="right"
          rows="1"
          autosize
          label="所属合同："
          type="textarea"
          readonly
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="item.amount"
          readonly
          clearable
          class="ggInput"
          input-align="right"
          label="开票金额（元）："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="item.typeName"
          readonly
          clearable
          class="ggInput"
          input-align="right"
          label="发票类型："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary" v-if="item.oppositeTallage!=''">
        <van-field
          v-model="item.oppositeTallage"
          readonly
          type="textarea"
          rows="1"
          autosize
          class="ggInput textArea"
          input-align="right"
          label="对方税号："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu dwBox">
        <van-field
          v-model="item.oppositeCompany"
          readonly
          clearable
          class="ggInput"
          rows="1"
          autosize
          type="textarea"
          input-align="right"
          label="对方单位名称："
        />
      </van-cell-group>
      <van-cell-group class="baseNone beizhu">
        <van-field
          v-model="item.reason"
          rows="1"
          autosize
          type="textarea"
          label="备注："
          input-align="right"
          readonly
        />
      </van-cell-group>
    </div>
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
      >提交</van-button>
    </div>
    <!-- 弹出框 -->
      <!-- 时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { dateFormat, dateTimeFormat, } from "@/utils/common";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "returnInvoice",
  data() {
    return {
      orgId: "",
      commonId: "", //发票id
      commonType: "",
      anountInfoId: "", //到账id
      mode: "add",
      editType: false,
      propertyData: [
        //累计金额等信息
        {
          contractName: "", // 所属合同名称
          amount: "", // 申请开票金额
          type: "", // 发票类型
          oppositeTallage: "", // 对方单位税号
          oppositeCompany: "", // 对方单位名称
          reason: "" //开票原因
        }
      ],
      invoiceData: {
        accountTime: "", //到账时间
        onceAmount: "", //本次到账金额
        amount: "", //开票金额
        amountTotal: "", //累计（办理、分配）金额
        amountRemain: "", //未（办理、分配）金额
        num: "", //发票号
        oppositeTallage: "" //税号
      },
      delPower: "",
      delType: false,
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      refreshPage: false, // 网络请求失败时显示
       showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(2015, 1, 1),
      clientType: getDeviceType() //手机类型
    };
  },
  mounted() {
    window.getKpIds = this.getKpIds;
    this.orgId = this.$route.query.orgId; //机构Id
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看=>可以撤回操作
    this.delPower = this.$route.query.delPower || ""; //财务撤回权限
    this.delType = this.delPower == "true" ? true : false;
    this.editType = this.mode == "add" ? true : false;
    this.initPage();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      if (this.clientType == "android") {
        window.android.getInfo(107);
      } else {
        window.webkit.messageHandlers.getKpIds.postMessage(null);
      }
      this.getDetail();
      this.getByMakeId();
    },
    jumpUrl() {
      let Url = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      let token = this.$route.query.token;
      if (
        this.invoiceData.amountTotal == "0" ||
        this.invoiceData.amountTotal == ""
      ) {
        return;
      } else {
        Url =
          Url +
          "/OA-pageH5/#/delHkList?token=" +
          token +
          "&commonId=" +
          this.commonId +
          "&commonType=fp&orgId=" +
          this.orgId +
          "&pageType=1";
        if (this.clientType == "android") {
          window.android.getInfo(112, Url);
        } else {
          //IOS
          console.log(Url);
          window.webkit.messageHandlers.getJumpUrl.postMessage(Url);
        }
        // }
      }
    },
    getKpIds(data) {
      let ids = "";
      if (this.clientType == "android") {
        ids = data;
      } else {
        ids = JSON.parse(data);
      }
      this.detailFuction(ids);
    },
    detailFuction(ids) {
      let _this = this;
      _this.$api.finance.account
        .getListByInvoiceId(ids)
        .then(res => {
          _this.setShowLoad(false);
          if (res.code == "1") {
            _this.propertyData = res.data;
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getDetail() {
      let _this = this;
      _this.$api.finance.account
        .viewAmount({ relationId: _this.commonId, accountType: "fp" })
        .then(res => {
          _this.setShowLoad(false);
          if (res.code == "1") {
            _this.invoiceData = newApi.assign({}, _this.invoiceData, res.data);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getByMakeId() {
      let _this = this;
      _this.$api.finance.account
        .getByMakeId(_this.commonId)
        .then(res => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data);
            _this.$set(_this.invoiceData, "num", res.data.num); //开票号
            _this.$set(
              _this.invoiceData,
              "oppositeTallage",
              res.data.oppositeTallage
            ); //开票号
          } else {
            console.log(res.msg);
          }
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    moneyOnceChange() {
      if (
        parseFloat(this.invoiceData.amountRemain) -
          parseFloat(this.invoiceData.onceAmount) <
        0
      ) {
        this.$set(this.invoiceData, "onceAmount", "");
        this.$toast("本次到账金额不能大于未到账金额");
      }
    },
    //时间弹框
     TimePicker(type) {
      if (this.editType) {
        this.showTimePicker = true;
      }
    },
     onTimeConfirm(data) {
      this.showTimePicker = false;
    
       this.invoiceData.accountTime = dateTimeFormat(data);
    },
    checkInput() {
      if (
        this.invoiceData.onceAmount == "" ||
        this.invoiceData.onceAmount == "0"||
        this.invoiceData.accountTime == ""
      ) {
        this.$toast("带星号为必填，不能为空或0");
      } else {
        this.saveDzPrice();
      }
    },

    saveDzPrice() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.finance.account
        .returnInvoice({
          relationId: _this.commonId,
          amount: _this.invoiceData.onceAmount,
          accountTime:_this.invoiceData.accountTime
        })
        .then(res => {
          if (res.code == "1" && res.data != null) {
            let text = "提交成功";
            closePage(text);
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch(err => {
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    }
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>
<style lang="less">
.returnInvoicePage {
  width: 100%;
  min-height: 100%;
  background-color: #f6f6f6;
  .title {
    position: relative;
    padding: 0 16px 0 25px;
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    position: relative;
    color: #2581d6;
    font-weight: 700;
    border-bottom: 1px solid #e0e0e0;
  }
  .title:before {
    content: "";
    position: absolute;
    width: 5px;
    height: 21px;
    background: #2581d6;
    top: 12px;
    left: 16px;
  }
  .warp {
    padding-bottom: 80px;
  }
  .baseNone::after {
    content: none;
  }
  .baseNone {
    border-bottom: 1px solid #f6f6f6;
  }
   .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu,
  .ggInput.textArea {
    min-height: 25px;
  }
  .listUl {
    width: 100%;
    background-color: #fff;
  }
  .listLi {
    align-items: flex-end;
    padding-bottom: 10px;
  }

  .claimDetailLists {
    border-bottom: 1px solid #f6f6f6;
    background-color: #fff;
  }
  .dzfp.claimDetailLists {
    margin-top: 10px;
  }
  .dwBox {
    .ggInput {
      .van-cell__title {
        width: 180px;
      }
    }
  }
  .ljdz {
    border-bottom: 1px solid #f6f6f6;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
    }
  }
}
</style>